// @flow

import { connectRouteTo } from 'redux-router-kit';

import { LinkProvider } from '@zapier/common-hooks';

export default connectRouteTo(LinkProvider);
